import appreciationDefaults from "./appreciation-defaults.json";

export * from "./energyAppreciation";
export * from "./registerAppreciation";

export interface AppreciationDefault {
    text: string | null;
    pdf_title: string;
}

export const APPRECIATION_DEFAULTS = appreciationDefaults as Record<string, AppreciationDefault>;
